import classes from "../../styles/components/statusButtons.module.scss";

function StatusCompletedButton() {
    return(
        <button className={`${classes.completed} ${classes.button}`}>● completed</button>
    );
}

export default StatusCompletedButton;